import PropTypes from "prop-types";

import CheckIcon from "@/icons/CheckIcon";
import WrongAnswerIcon from "@/icons/WrongAnswerIcon";
import {
  answerIconsIndicatorCss,
  leftSideAnswerIndicatorCss,
  rightSideAnswerIndicatorCss,
  checkIconStyles,
  closeIconStyleCss,
} from "./PowerWordStatusResponseIcons.styles";

const propTypes = {
  answerStatus: PropTypes.array,
};

const PowerWordStatusResponseIcons = ({ answerStatus }) => {
  const [firstAnswerStatus, secondAnswerStatus] = answerStatus;
  const renderCorrectlyIcon = (isCorrectAnswer) =>
    isCorrectAnswer ? (
      <CheckIcon css={checkIconStyles} />
    ) : (
      <WrongAnswerIcon css={closeIconStyleCss} />
    );

  return (
    <div css={answerIconsIndicatorCss}>
      <span css={leftSideAnswerIndicatorCss(firstAnswerStatus)}>
        {renderCorrectlyIcon(firstAnswerStatus)}
      </span>
      <span css={rightSideAnswerIndicatorCss(secondAnswerStatus)}>
        {renderCorrectlyIcon(secondAnswerStatus)}
      </span>
    </div>
  );
};

PowerWordStatusResponseIcons.propTypes = propTypes;
export default PowerWordStatusResponseIcons;
